import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';


const createOffsiteAPI = (value) => {

    let payload = {
        "name": value.name, //driver dropdown value
        "requestDateTime": value.requestDateTime,
        "changeType": value.changeType,
        "department": value.department,
        "requesterName": value.requesterName,
        "productNum": value.productNum,
        "actualCount": value.actualCount,
        "sealNum": value.sealNum,
        "notes": value.notes,
        "truck": value.truck
    }


    return APICallingService.sendRequestForPostWithAuth(url.addOffSite, payload, false, (res) => {

    }, true);

}

function* createOffSite(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createOffsiteAPI, action.payload.value);

        if (response && response?.callBackStatus.toLowerCase() == 'success') {

            let obj = {
                offSiteType: 1,
                pageNo: 1,
                limit: 10

            }
            yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.ADD_OFFSITE_API_SUCCESS, payload: { value: response?.callBackStatus } });

            yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL, payload: { value: obj } });


        }
        else {
            if (response && response != null && response.Status != 405) {

                yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.ADD_OFFSITE_API_SUCCESS, payload: { value: response?.callBackStatus } });

                alert('Failed to create offsite');
            }
        }


    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.ADD_OFFSITE_API_SUCCESS, payload: { value: 'Failed' } });

    }


}

const getOffSiteAPI = (value) => {

    let offSiteUrl = url.getOffSiteRequest + value.offSiteType + "/" + value.pageNo + "/" + value.limit;
    return APICallingService.sendRequestForGet(offSiteUrl, (res) => {
    }, true);

}

function* getOffSite(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getOffSiteAPI, action.payload.value);
        if (response && response != null) {
            let completedArray = [], inProgressArray = [], pendingArray = [], allOffSiteTraileArray = [];
            for (let index = 0; index < response.data.length; index++) {
                const element = response.data[index];


            }
            yield put({
                type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_API_SUCCESS, payload: { value: response.data }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get offsite')
                yield put({
                    type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_API_SUCCESS, payload: { value: 'Failed' }
                })
            }
        }


    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_API_SUCCESS, payload: { value: 'Failed' }
        })
    }


}

export { getOffSite, createOffSite };
